import {IRegistryProfileInitialValues} from "../../../../types/registry";

export default {
    firstname: "",
    surname: "",
    // email: "",
    phone: "",
} as IRegistryProfileInitialValues
